import { Send, MessageCircle } from 'lucide-react';
import { m } from 'framer-motion';
import { useSiteData } from '../context/SiteContext';

export const FloatingMessengers = () => {
  const { data } = useSiteData();

  const telegramUrl = data?.settings?.tg_link || "https://t.me/krasagency?text=Здравствуйте!%20Хочу%20получить%20консультацию%20по%20рекламе.";
  const maxUrl = data?.settings?.vk_link || "https://vk.me/krasagency?ref=Здравствуйте!%20Хочу%20получить%20консультацию%20по%20рекламе.";

  return (
    <m.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1 }}
      className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3 bg-white dark:bg-gray-800 p-2 rounded-full shadow-xl border border-gray-100 dark:border-gray-700 transition-colors duration-300"
    >
      <a 
        href={maxUrl} 
        target="_blank" 
        rel="noreferrer"
        className="w-12 h-12 bg-[#0077FF] text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-md"
        title="Написать Максу (VK)"
        aria-label="Написать Максу (VK)"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a 
        href={telegramUrl} 
        target="_blank" 
        rel="noreferrer"
        className="w-12 h-12 bg-[#229ED9] text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-md"
        title="Написать в Telegram"
        aria-label="Написать в Telegram"
      >
        <Send className="w-5 h-5 -ml-1 mt-0.5" />
      </a>
    </m.div>
  );
};